import {MainVideoState} from "../definitions/MainVideoState";

export const mouseInactive = (state: MainVideoState) => {
    state.projectState.showFullScreenControlBar = false;
};
